import { estEtoile } from '@rh/shared';

/**
 * Étoile des candidats à potentiel élevé : posée d'office quand la pastille est
 * à 5 (décision du 2026-09-15), rien à cocher. Le libellé accompagne l'icône
 * pour les lecteurs d'écran.
 */
export function Etoile({ potentiel }: { potentiel: number | null | undefined }) {
  if (!estEtoile(potentiel)) return null;
  return (
    <span className="etoile" title="Potentiel élevé : pastille 5" role="img" aria-label="Candidat étoilé, potentiel élevé">
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
        <path
          d="M12 2.8l2.8 5.7 6.3.9-4.6 4.4 1.1 6.3L12 17.1l-5.6 3 1.1-6.3-4.6-4.4 6.3-.9z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
